







import { Component, Vue } from 'vue-property-decorator';

@Component({

    props: {

        variant: {

            type: String,

        },

    },

})

export default class Badge extends Vue {
}
